import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Callout, Eyebrow } from '@/shared/components/cse'
import { formatIsoDateTimeDisplay } from '@/shared/lib/datetime'

/**
 * Full-screen maintenance takeover (T4.7). Presentational: the gate controls when it
 * mounts. `message`/`retryAfter` come from the 503 problem body when the server provides
 * them, otherwise the static i18n copy stands alone.
 */
export function MaintenancePage({
  message,
  retryAfter,
}: {
  message?: string | null
  retryAfter?: string | null
}) {
  const { t } = useTranslation()
  const retryLabel = retryAfter ? formatIsoDateTimeDisplay(retryAfter) : null

  return (
    <div
      role="main"
      aria-labelledby="maintenance-title"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 overflow-y-auto bg-background px-6 py-16 text-center text-foreground"
    >
      <Eyebrow>{t('ui.maintenance.eyebrow')}</Eyebrow>
      <h1 id="maintenance-title" className="font-display text-3xl text-foreground">
        {t('ui.maintenance.title')}
      </h1>
      <p className="max-w-md text-muted-foreground">{t('ui.maintenance.description')}</p>

      {message ? (
        <Callout tone="neutral" className="max-w-md text-left">
          {message}
        </Callout>
      ) : null}

      {retryLabel ? (
        <p className="text-sm text-muted-foreground">{t('ui.maintenance.retry_after', { time: retryLabel })}</p>
      ) : null}

      <Button onClick={() => window.location.reload()} className="mt-2">
        {t('ui.maintenance.retry')}
      </Button>
    </div>
  )
}
